import styled from "styled-components";

export const List = styled.section`
    display: flex;
    flex-direction: column;
`